import GridCell from "../GridCell/GridCell";
import { ReactNode } from "react";

interface GridRowProps {
  children: ReactNode | ReactNode[];
}

/**
 * Should be a child component of a GridRow. Used for main content on pages, like
 * the main body of an article. Skips one column on desktop and takes up 6 columns.
 * Uses full width on tablet and mobile.
 */
const GridPresetOffsetWideContent = ({ children }: GridRowProps) => (
  <GridCell
    startColsDesktop={2}
    spanColsDesktop={12}
    startColsTablet={1}
    spanColsTablet={6}
    startColsMobile={1}
    spanColsMobile={6}
  >
    {children}
  </GridCell>
);

export default GridPresetOffsetWideContent;
